import { KeyboardBackspace } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "src/hooks/useIsMobile";
import ManageCard from "./components/ManageCard";

const ManageSubscription = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const page = "subscriptions.manage";

  return (
    <Stack width="100%" gap={2}>
      <Stack
        direction={!isMobile ? "column" : "row"}
        alignItems={!isMobile ? "" : "center"}
        gap={1}
      >
        <Stack direction="row" alignItems="center">
          <IconButton sx={{ color: "#00B6B8" }} onClick={() => navigate(-1)}>
            <KeyboardBackspace fontSize={!isMobile ? "small" : "large"} />
          </IconButton>
          {!isMobile ? (
            <Typography color="#00B6B8">{t(`back`, "Back")}</Typography>
          ) : null}
        </Stack>
        <Typography variant="h5" fontWeight={700}>
          {t(`${page}.header`, "Manage Your Subscription")}
        </Typography>
      </Stack>
      <ManageCard />
    </Stack>
  );
};

export default ManageSubscription;
